import { useState } from 'react';

import { MouseTooltip } from 'components/ui/MouseTooltip';
import type { YardGateEntry } from '../../adapter';

interface AnnotationCellProps {
  entry: YardGateEntry;
}

export const AnnotationCell = ({ entry }: AnnotationCellProps) => {
  const [hover, setHover] = useState<{ x: number; y: number } | null>(null);
  const canShowTooltip =
    entry.status !== 'CANCELLED' && entry.status !== 'NO_SHOW';

  return (
    <>
      <span
        className="inline-flex max-w-[220px] items-center gap-1"
        onMouseMove={(event) =>
          setHover({ x: event.clientX, y: event.clientY })
        }
        onMouseLeave={() => setHover(null)}
      >
        <span className="truncate">{entry.annotation || '—'}</span>
      </span>
      {hover && canShowTooltip && entry.annotation ? (
        <MouseTooltip
          x={hover.x}
          y={hover.y}
          title="Anotações"
          description={entry.annotation}
        />
      ) : null}
    </>
  );
};
